import { createBrowserHistory } from 'history'
import config from 'const/config'

export const history = createBrowserHistory({
  basename: config.BASENAME
})

export const redirectTo = (page = '/', isReplace = false): void => {
  if (isReplace) {
    history.replace(page)
  } else {
    history.push(page)
  }
}

export const redirectToAccountSummary = (): void => {
  redirectTo('summary')
}

export const refreshPage = (): void => history.go(0)
